import useBriefContext from '../../../../../../Hooks/Brief/useBriefContext'
import captureMessage from '../../../../../../Utilities/Errors/captureMessage'
import ATTRIBUTES_BY_EVENT_TYPE from '../../../../EventType/Base/Logic/attributesByEventType'

const GuestLabel = (): JSX.Element => {
  const {
    brief: { collectionName },
  } = useBriefContext()

  if (!collectionName)
    throw new Error('Missing event type in type-specific number-of-guests component!')

  const typeAttrs = ATTRIBUTES_BY_EVENT_TYPE[collectionName]

  if (!typeAttrs) {
    captureMessage(
      `Missing 'GuestNumberInput' attrs for event type ${collectionName} in guest label component`
    )
  }

  const guestLabel = typeAttrs?.guestLabel ?? 'guests'

  return <span aria-hidden={true}>{guestLabel}</span>
}

export default GuestLabel
